module.exports = "/_next/static/images/shoptet-13ed7947e89e3407c9fbf41068336608.png";